import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Label, Button, Alert, Spinner } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { ToastContainer, toast } from "react-toastify";
import { saveRecords } from "../../services/api.service";
import logo from "../../assets/images/logo/LoginImg.png";

const ForgetPasswordPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const handleValidSubmit = async (event, values) => {
    setLoading(true);

    try {
      if (!otpSent) {
        const response = await saveRecords(values, "/auth/forgot-password");
        toast.success(response.message);
        setOtpSent(true);
        return;
      }

      const payload = {
        email: values.email,
        otp: values.otp,
        newPassword: values.password,
        confirmPassword: values.confirm_password,
      };

      const response = await saveRecords(payload, "/auth/reset-password");

      if (response.status) {
        toast.success(response.message);
        navigate("/login");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />

      {/* Loading overlay */}
      {loading && (
        <div className="loading-overlay">
          <Spinner size="sm" color="primary" />
        </div>
      )}

      <div className="login-bg">
        <Container>
          <Row className="justify-content-center">
            <Col lg={4} md={6}>
              <div className="login-card p-4">
                <div className="text-center mb-4">
                  <img src={logo} height="100" alt="logo" />
                  <h4 className="mt-3">Reset Password</h4>
                </div>

                <AvForm onValidSubmit={handleValidSubmit}>
                  {/* EMAIL FIELD */}
                  <div className="auth-form-group-custom mb-4">
                    <Label htmlFor="email">email</Label>
                    <AvField
                      name="email"
                      type="email"
                      className="form-control"
                      placeholder="Enter email"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Email cannot be blank.",
                        },
                      }}
                      onChange={() => setOtpSent(false)}
                    />
                  </div>

                  {/* OTP + PASSWORD FIELDS */}
                  {otpSent && (
                    <>
                      {/* OTP */}
                      <div className="auth-form-group-custom mb-4">
                        <Label>OTP</Label>
                        <AvField
                          name="otp"
                          type="text"
                          className="form-control custom-input"
                          placeholder="Enter OTP"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "OTP cannot be blank.",
                            },
                          }}
                        />
                      </div>

                      {/* New Password */}
                      <div className="auth-form-group-custom mb-4 position-relative">
                        <i className="ri-lock-2-line icon-style"></i>
                        <Label>New Password</Label>
                        <AvField
                          name="password"
                          value={password}
                          type={passwordVisible ? "text" : "password"}
                          className="form-control custom-input"
                          placeholder="New password"
                          onChange={(e) => setPassword(e.target.value)}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "Password cannot be blank.",
                            },
                            minLength: {
                              value: 6,
                              errorMessage: "Min 6 characters required",
                            },
                          }}
                        />
                        {password && (
                          <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() => setPasswordVisible(!passwordVisible)}
                          >
                            <i
                              className={
                                passwordVisible
                                  ? "ri-eye-line"
                                  : "ri-eye-off-line"
                              }
                            ></i>
                          </button>
                        )}
                      </div>

                      {/* Confirm Password */}
                      <div className="auth-form-group-custom mb-4 position-relative">
                        <i className="ri-lock-2-line icon-style"></i>
                        <Label>Confirm Password</Label>
                        <AvField
                          name="confirm_password"
                          type={confirmPasswordVisible ? "text" : "password"}
                          value={confirmPassword}
                          className="form-control custom-input"
                          placeholder="Confirm password"
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "Confirm password cannot be blank.",
                            },
                            match: {
                              value: "password",
                              errorMessage: "Passwords do not match",
                            },
                          }}
                        />
                        {confirmPassword && (
                          <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() =>
                              setConfirmPasswordVisible(!confirmPasswordVisible)
                            }
                          >
                            <i
                              className={
                                confirmPasswordVisible
                                  ? "ri-eye-line"
                                  : "ri-eye-off-line"
                              }
                            ></i>
                          </button>
                        )}
                      </div>
                    </>
                  )}

                  {/* BUTTON */}
                  <div className="mt-4 text-center">
                    <Button className="login-btn w-100" type="submit">
                      {otpSent ? "Reset Password" : "Reset"}
                    </Button>
                  </div>

                  <div className="mt-4 text-center">
                    <Link to="/login" className="forgot-link">
                      Back to login
                    </Link>
                  </div>
                </AvForm>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* SHARED STYLING */}
      <style jsx>{`
        .login-bg {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(
            135deg,
            #d31027 0%,
            #ea6b0b 40%,
            #8e2de2 100%
          );
        }

        .login-card {
          background: #fff;
          border-radius: 18px;
          padding: 40px;
          box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.15);
          animation: fadeIn 0.4s ease-in-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .custom-input {
          border-radius: 10px;
          padding-left: 42px !important;
          height: 48px;
        }

        .icon-style {
          position: absolute;
          left: 12px;
          top: 42px;
          font-size: 1.3rem;
          color: #888;
        }

        .password-toggle-btn {
          position: absolute;
          top: 42px;
          right: 12px;
          background: transparent;
          border: none;
          cursor: pointer;
          font-size: 1.3rem;
          color: #777;
        }

        .login-btn {
          background: #006eb9 !important;
          border-radius: 10px;
          height: 45px;
          font-size: 16px;
        }

        .forgot-link {
          color: #006eb9;
          text-decoration: none;
        }

        .forgot-link:hover {
          text-decoration: underline;
        }

        .loading-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }
      `}</style>
    </React.Fragment>
  );
};

export default ForgetPasswordPage;
